import React from "react";
import "./Services.css";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import {
    FaGlobe,
    FaMapMarkedAlt,
    FaRegSmile,
    FaUmbrellaBeach,
    FaHotel,
    FaCar,
    FaUserTie,
    FaUtensils,
    FaTheaterMasks,
    FaHandshake,
    FaNetworkWired
} from "react-icons/fa";

const Services = () => {
    const { t } = useTranslation();

    const servicesCards = [
        { icon: <FaGlobe />, key: "individual" },
        { icon: <FaMapMarkedAlt />, key: "historical" },
        { icon: <FaRegSmile />, key: "eco" },
        { icon: <FaUmbrellaBeach />, key: "adventure" },
        { icon: <FaHotel />, key: "hotel" },
        { icon: <FaCar />, key: "transport" },
        { icon: <FaUserTie />, key: "guide" },
        { icon: <FaUtensils />, key: "gastro" },
        { icon: <FaTheaterMasks />, key: "cultural" },
        { icon: <FaHandshake />, key: "fullSupport" },
        { icon: <FaNetworkWired />, key: "international" }
    ];

    return (
        <main className="services-page">

            <Helmet>
                <title>{t("services.helmetTitle")}</title>
                <meta name="description" content={t("services.helmetDescription")} />
            </Helmet>

            <section className="services-section">

                {/* LEFT SIDE */}
                <div className="services-left">

                    <h1 className="services-title">
                        🌍 {t("services.title")}
                    </h1>

                    <p className="services-text">
                        <strong>✨ ADAM VOYAGE</strong> — {t("services.intro1")}
                    </p>

                    <p className="services-text">
                        {t("services.intro2")}
                    </p>

                    {/* DETAILS LIST */}
                    <div className="services-list">

                        {servicesCards.map((item, idx) => (
                            <div className="service-item" key={idx}>
                                <h3>
                                    {item.icon} {t(`services.items.${item.key}.title`)}
                                </h3>
                                <p>
                                    {t(`services.items.${item.key}.desc`)}
                                </p>
                            </div>
                        ))}

                    </div>

                    <p className="services-text">
                        ✈️ {t("services.outro")} <strong>ADAM VOYAGE</strong> {t("services.outroSuffix")}
                    </p>

                    <button
                        className="about-gold-btn"
                        onClick={() => window.location.href = "/contact"}
                    >
                        📩 {t("services.contactBtn")}
                    </button>

                </div>

                {/* RIGHT SIDE (CARDS ONLY) */}
                <div className="services-right">

                    {servicesCards.map((item, idx) => (
                        <div className="service-card" key={idx}>
                            <div className="service-icon">
                                {item.icon}
                            </div>

                            <h3 className="service-title">
                                {t(`services.cards.${item.key}`)}
                            </h3>
                        </div>
                    ))}

                </div>

            </section>

        </main>
    );
};

export default Services;